/// <reference path="../../node_modules/@types/jquery/index.d.ts" />
import { fixFullHeight } from "./shared";

// Sidebar
$(document).ready(function () {

    var $SIDEBAR_MENU = $('nav.navigation'),
        CURRENT_URL = window.location.pathname.toLowerCase(),
        $BODY = $('body'),
        $RIGHT_COL = $('.right_col'),
        $LEFT_COL = $('.left_col'),
        $SIDEBAR_FOOTER = $('.sidebar-footer'),
        $MENU_TOGGLE = $('#menu_toggle'),
        $NAV_MENU = $('.nav_menu'),
        $FOOTER = $('footer');


    // TODO: This is some kind of easy fix, maybe we can improve this
    var setContentHeight = function () {
        // reset height
        $RIGHT_COL.css('min-height', $(window).height());

        var bodyHeight = $BODY.outerHeight(),
            footerHeight = $BODY.hasClass('footer_fixed') ? -10 : $FOOTER.height(),
            leftColHeight = $LEFT_COL.eq(1).height() + $SIDEBAR_FOOTER.height(),
            contentHeight = bodyHeight < leftColHeight ? leftColHeight : bodyHeight;

        // normalize content
        contentHeight -= $NAV_MENU.height() + footerHeight;

        $RIGHT_COL.css('min-height', contentHeight);
    };

    $SIDEBAR_MENU.find('.nav.side-menu a:not([href])').on('click', function (ev) {
        var $li = $(this).parent();

        if ($li.is('.active') || $li.is('.active-sm') && $li.find('.nav.child_menu').css('display') != 'none') {
            $li.removeClass('active active-sm');
            $('ul:first', $li).slideUp(function () {
                setContentHeight();
            });
        } else {
            // prevent closing menu if we are on child menu
            if (!$li.parent().is('.child_menu')) {
                $SIDEBAR_MENU.find('li').removeClass('active active-sm');
                $SIDEBAR_MENU.find('li ul').slideUp();
            }
            if ($BODY.hasClass('nav-md')) {
                $li.addClass('active');
            }
            else if ($BODY.hasClass('nav-sm')) {
                $li.addClass('active-sm');
            }

            $('ul:first', $li).slideDown(function () {
                setContentHeight();
            });
        }
    });

    // toggle small or large menu
    $MENU_TOGGLE.on('click', function () {
        if ($BODY.hasClass('nav-md')) {
            $SIDEBAR_MENU.find('li.active ul').hide();
            $SIDEBAR_MENU.find('li.active').addClass('active-sm').removeClass('active');
        } else {
            $SIDEBAR_MENU.find('li.active-sm ul').show();
            $SIDEBAR_MENU.find('li.active-sm').addClass('active').removeClass('active-sm');
        }

        $BODY.toggleClass('nav-md nav-sm');
        $(window).resize();
        //setContentHeight();
    });

    // check active menu
    //$SIDEBAR_MENU.find('a[href="' + CURRENT_URL + '"]').parent('li').addClass('current-page');

    $SIDEBAR_MENU.find('a').filter(function () {
        let href = $(this).attr('href') as string || "";
        return href.toLowerCase() == CURRENT_URL;
    }).parent('li').addClass('current-page').parents('ul').slideDown(function () {
        setContentHeight();
    }).parent().addClass('active here');

    // recompute content when resizing
    //$(window).smartresize(function () {
    //    setContentHeight();
    //});

    setContentHeight();
});
// /Sidebar

// full_height_fixed
$(document).ready(() => {
    fixFullHeight();
})

$(window).on('resize', () => {
    fixFullHeight();
});

$('.language-selector').kendoDropDownList({
    dataSource: [
        { text: "ENG", value: "en" },
        { text: "ITA", value: "it" }
    ],
    dataTextField: "text",
    dataValueField: "value",
    change: (evt) => {
        let selected = evt.sender.dataItem();
        setCookie('.AspNetCore.Culture', `c=${selected.value}|uic=${selected.value}`, null);
        evt.preventDefault();
        location.reload();
    },
    value: $("html").attr("lang")
});

function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}


// WEBPACK FOOTER //
// ./js/mmon.ts